import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
    tabpanel: {
        height: 500
    },
    customTabRoot: {
        color: '#2F4857',
        backgroundColor: '#FFFFFF'
    },
    customTabIndicator: {
        backgroundColor: '#3E9BD9'
    },
    root: {
        minWidth: 275,
        height: 'auto'
    },
    wrapperTab: {
        flexDirection: 'row'
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)'
    },
    title: {
        fontSize: 14,
        color: '#2F4857',
        fontFamily: 'Montserrat'
    },
    subtitle: {
        fontSize: 14,
        color: '#9EAAB0'
    },
    pos: {
        marginBottom: 12
    },
    actionConatiner: {
        justifyContent: 'flex-end'
    },
    flexStart: {
        justifyContent: 'flex-start'
    },
    save: {
        width: 120
    },
    line: {
        width: '100%',
        height: 1,
        right: 24,
        marginBottom: 5,
        background: '#DDE2E3',
        transform: 'matrix(1, 0, 0, -1, 0, 0)'
    },
    progressBar: {
        padding: 10,
        width: 350,
        height: 'auto',
        left: 29,
        border: '1px dashed #DCE2E3',
        boxSizing: 'border-box',
        borderRadius: 10
    },
    progressBarHeading: {
        width: 66,
        height: 19,
        left: 42,
        top: 122,
        fontFamily: 'Nunito',
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: 14,
        lineHeight: 19,
        display: 'flex',
        alignItems: 'center',
        textAlign: 'center',
        color: '#2F4857'
    },
    progressBarSubHeading: {
        width: 145,
        height: 14,
        fontFamily: 'Nunito',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: 10,
        color: '#9EAAB0'
    },
    dropZone: {
        fullWidth: 'true',
        width: 350,
        height: 136,
        background: 'rgba(62, 155, 217, 0.1)',
        border: '1px dashed #3E9BD9',
        boxSizing: 'border-box',
        borderRadius: 10
    },
    previewContainer: {
        container: 'true',
        width: '100%',
        height: '100%'
    },
    dropZoneContainer: {
        // height: 250
    },
    textBox: {
        left: '2.82%',
        right: '56%',
        top: '65.61%',
        bottom: '24.63%',
        background: '#FFFFFF',
        border: '1px solid #DCE2E3',
        boxSizing: 'border-box',
        borderRadius: 6
    },
    preview: {
        height: '150px'
    },
    datepicker: {
        marginRight: 8,
        width: '100% !important',
        maxWidth: '100% !important',
        borderRadius: '5px !important',
        border: '1px solid #DCE2E3 !important'
    },
    progressTitle: {
        fontSize: 14,
        fontWeight: 600,
        color: '#2F4857',
        margin: 0
    },
    progressDate: {
        fontSize: 11,
        fontWeight: 400,
        color: '#9EAAB0',
        margin: 0
    },
    progressDateError: {
        fontSize: 11,
        fontWeight: 400,
        color: '#C41D10',
        margin: 0
    },
    error: {
        color: '#C41D10',
        padding: 5
    }
}));

export default useStyles;
